type Tone =
  | 'healthy'
  | 'low'
  | 'medium'
  | 'high'
  | 'critical'
  | 'neutral'
  | 'inactive'
  | 'migrate'
  | 'retire'
  | 'old-api';

const STYLES: Record<Tone, string> = {
  healthy: 'bg-grow/15 text-grow border-grow/40',
  low: 'bg-neutral-700/40 text-neutral-300 border-neutral-600',
  medium: 'bg-sunrise/15 text-sunrise border-sunrise/40',
  high: 'bg-sunrise/20 text-sunrise border-sunrise/50',
  critical: 'bg-sunset/20 text-sunset border-sunset/50',
  neutral: 'bg-surface-3 text-neutral-400 border-border',
  inactive: 'bg-neutral-700/40 text-neutral-400 border-neutral-600',
  migrate: 'bg-deliver/15 text-deliver border-deliver/40',
  retire: 'bg-sunset/20 text-sunset border-sunset/50',
  'old-api': 'bg-sunrise/15 text-sunrise border-sunrise/40',
};

export function RiskBadge({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded border whitespace-nowrap ${STYLES[tone]}`}
    >
      {children}
    </span>
  );
}
